import React from 'react';
import { Link } from 'react-router-dom';
import NotFound from './common/404';
import GetInTouch from './common/getInTouch';
import Meta from './common/meta';
import projectData from '../data/projectData';

class Project extends React.Component {
  render() {
    const projectName = this.props.match && this.props.match.params ? this.props.match.params.name : null;
    const project = projectData.project.find((p) => p.url === projectName);

    if (!project) {
      return <NotFound />;
    }

    return (
      <article className="project-details">
        <Meta data={project} />

        {/* Header Breadcrumb & Overview */}
        <section className="bg-light py-4 border-bottom mb-4">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb bg-transparent p-0 mb-3 small">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/">Projects</Link></li>
                <li className="breadcrumb-item active" aria-current="page">{project.name}</li>
              </ol>
            </nav>

            <div className="row align-items-center">
              <div className="col-lg-9 mx-auto text-center">
                {project.category && (
                  <div className="mb-2">
                    <span className="badge badge-primary px-3 py-1 text-uppercase">{project.category}</span>
                  </div>
                )}
                <h1 className="display-4 font-weight-bold text-dark mb-3" style={{ fontSize: '2.25rem' }}>
                  {project.name}
                </h1>
                <p className="lead text-secondary mb-4" style={{ fontSize: '1.15rem' }}>
                  {project.desc}
                </p>

                <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mb-4">
                  {project.role && (
                    <span className="badge badge-dark px-3 py-2 mr-2 mb-2">
                      <i className="fa fa-user-tag mr-1" aria-hidden="true"></i> Role: {project.role}
                    </span>
                  )}
                  {project.website && (
                    <a 
                      href={project.website} 
                      target="_blank" 
                      rel="nofollow noopener noreferrer"
                      className="btn btn-outline-primary btn-sm rounded-pill px-4 py-2 font-weight-bold mb-2 shadow-sm"
                    >
                      <i className="fa fa-external-link-alt mr-2" aria-hidden="true"></i> Live Website
                    </a>
                  )}
                </div>

                {project.technologies && project.technologies.length > 0 && (
                  <div className="mt-3">
                    <span className="text-muted small mr-2 font-weight-bold">Technologies Used:</span>
                    {project.technologies.map((tech, idx) => (
                      <span key={idx} className="badge badge-info px-2 py-1 mr-1 mb-1 font-weight-normal">
                        {tech}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Project Features & Details */}
        <div className="container my-4">
          {project.features && project.features.length > 0 && (
            <div className="row justify-content-center mb-5">
              <div className="col-lg-8">
                <div className="card shadow-sm border-0 rounded-lg p-4 bg-white">
                  <h2 className="h5 font-weight-bold border-bottom pb-2 mb-3">Key Features &amp; Highlights</h2>
                  <ul className="list-unstyled mb-0">
                    {project.features.map((feat, fIdx) => (
                      <li key={fIdx} className="mb-2 d-flex align-items-start">
                        <i className="fa fa-check-circle text-success mt-1 mr-3" aria-hidden="true"></i>
                        <span>{feat}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* Project Gallery */}
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h2 className="h4 font-weight-bold mb-4">Project Visuals &amp; Screenshots</h2>
              {project.gallery.map((imgName, index) => {
                const galleryImgPath = `/image/portfolio/${project.url}/${imgName}`;

                return (
                  <div key={index} className="mb-5">
                    <div className="d-flex justify-content-center align-items-center mb-2">
                      <span className="number-circle font-weight-bold">{index + 1}</span>
                    </div>
                    <div className="arrow bounce mb-3"></div>
                    <div className="card shadow-sm border-0 rounded-lg overflow-hidden p-2 bg-light">
                      <img 
                        src={galleryImgPath} 
                        className="img-fluid rounded" 
                        alt={`${project.name} screenshot ${index + 1}`}
                        loading="lazy" 
                        style={{ width: '100%', height: 'auto', maxHeight: '900px', objectFit: 'contain' }}
                      />
                    </div>
                  </div>
                );
              })}

              <h3 className="h5 font-weight-normal text-muted mt-4 mb-5">
                {project.footer}
              </h3>
            </div>
          </div>
        </div>

        <GetInTouch />
      </article>
    );
  }
}

export default Project;